"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shopifyProductApi = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
var shopifyProductApi = exports.shopifyProductApi = {
  findAll: function findAll(params) {
    return (0, _request.default)({
      url: '/shopifyProduct',
      params: params
    });
  },
  sync: function sync() {
    return (0, _request.default)({
      url: '/shopifyProduct/sync',
      method: 'GET'
    });
  }
};